import { Box, Button, Grid, Typography } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import CustomInput from '../../../../../../Components/CustomInput'
import DataClient from '../../../../../../Service/general_data_service'

const ansArr = [];
function Timeline(props) {
    console.log(`props`, props);
    const [localPageData, setLocalPageData] = useState([])

    useEffect(() => {
        if (props.pageData.length > 0) {

            localPageData.length = 0;
            setLocalPageData(localPageData.concat(props.pageData))
        }
    }, [props.pageData])

    const inputChangeHandler = (value, option) => {
        props.pageData.map((pageDataOption) => {
            if (pageDataOption.section_name == "Section B: Timelines and Logistics") {
                pageDataOption.coaching_agreement_form_fields.map((pageDataSubOption) => {
                    (pageDataSubOption.id == option.id) && (pageDataSubOption['answer'] = value)
                })
            }
        })
        localPageData.length = 0;
        setLocalPageData(localPageData.concat(props.pageData));

        var flag = true;
        if (ansArr.length > 0) {
            ansArr.map((ansArrOption) => {
                if (ansArrOption['coaching_agreement_form_field_id'] == option.id) {
                    ansArrOption.value = value;
                    flag = false;
                }
            })
        }
        if (flag) {
            ansArr.push({ "coaching_agreement_form_field_id": option.id, "value": value })
        }
    }
    const saveNext = () => {
        props.parentCall(props.tabIndex + 1)
        var pdata = {}
        localPageData.map((option) => {
            if (option.section_name == "Section B: Timelines and Logistics") {
                pdata['coaching_agreement_form_section_id'] = option.id
                pdata['additional_section_id'] = null
                pdata['assignment_id'] = props.assignment_id
                pdata['caf_answers'] = JSON.stringify(ansArr)
            }
        })
        DataClient.create(pdata, 'coaching_agreement_form_answers')
            .then((res) => {


            })
        console.log(`pdata`, pdata)

    }
    return <Box my={3}>
        <Grid container direction="row">
            {
                localPageData.length > 0 && localPageData.map((option) => {
                    if (option.section_name == "Section B: Timelines and Logistics") {

                        return option.coaching_agreement_form_fields.map((options) => {
                            return <Grid container direction="row" style={{ marginBottom: 10 }}>
                                <Grid item xs={6}>
                                    <Typography variant="h5">
                                        <Box mb={2}>{options.field_value}</Box>
                                    </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <CustomInput id="first_name" variant="outlined" value={options.answer} placeholder={options.field_value} parentcall={(text) => { inputChangeHandler(text, options) }} />
                                </Grid>
                            </Grid>
                        })
                    }
                })
            }

            <Grid container direction="row">
                <Grid item xs={12}>
                    <Grid container direction="row">
                        <Grid item xs={3}>
                            <Typography variant="h5">
                                <Box mb={2} >Coaching Dimensions</Box>
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant="h5">
                                <Box mb={2} fontWeight="fontWeightBold">Coaching Dimensions</Box>
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant="h5">
                                <Box mb={2} fontWeight="fontWeightBold">Duration</Box>
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant="h5">
                                <Box mb={2} fontWeight="fontWeightBold">Attendees</Box>
                            </Typography>
                        </Grid>
                    </Grid>
                    {
                        [1, 2, 2, 2, 2, 2].map((option) => {
                            return <Grid container direction="row">
                                <Grid item xs={3}>

                                </Grid>
                                <Grid item xs={3}>
                                    <Typography variant="h5">
                                        <Box mb={2} >Chemistry</Box>
                                    </Typography>
                                </Grid>
                                <Grid item xs={3}>
                                    <Typography variant="h5">
                                        <Box mb={2} >1 hour</Box>
                                    </Typography>
                                </Grid>
                                <Grid item xs={3}>
                                    <Typography variant="h5">
                                        <Box mb={2} >Coach, Coachee, HR</Box>
                                    </Typography>
                                </Grid>
                            </Grid>

                        })
                    }
                    <Grid container direction="row">
                        <Grid item xs={3}>

                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant="h5">
                                <Box mb={2} >Chemistry</Box>
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant="h5">
                                <Box mb={2} >1 hour</Box>
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant="h5">
                                <Box mb={2} >Coach, Coachee, HR</Box>
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>

            </Grid>

            <Grid container direction="row" >
                <Grid item xs={12}>
                    <Box textAlign="right" my={3}>
                        <Button variant="contained" color="secondary" style={{ textTransform: 'none' }} onClick={saveNext}>
                            Save and next
                        </Button>
                    </Box>
                </Grid>
            </Grid>

        </Grid>
    </Box>
}

export default Timeline
